import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getUserProjectsRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/user-projects");

  return response.data;
};
